import { render, staticRenderFns } from "./PlayBar.vue?vue&type=template&id=6b8d6bcc&scoped=true&"
import script from "./PlayBar.vue?vue&type=script&lang=js&"
export * from "./PlayBar.vue?vue&type=script&lang=js&"
import style0 from "./PlayBar.vue?vue&type=style&index=0&id=6b8d6bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8d6bcc",
  null
  
)

export default component.exports